import { render, staticRenderFns } from "./KT-VoiceComponent.vue?vue&type=template&id=4a1238ca&scoped=true&lang=pug&"
import script from "./KT-VoiceComponent.vue?vue&type=script&lang=js&"
export * from "./KT-VoiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./KT-VoiceComponent.vue?vue&type=style&index=0&id=4a1238ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1238ca",
  null
  
)

export default component.exports